// extracted by mini-css-extract-plugin
module.exports = {"h3CustomStyling":"RichTextComponent_h3CustomStyling__mfLD4"};